import React from 'react';
import { useParams } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

export default function ChainDetailPage() {
  const { slug } = useParams();
  // For MVP, chains map to owners (they're aggregated from organization-type owners).
  return <Navigate to={`/owners/${slug}`} replace />;
}
